import React from 'react';
import { WMSTileLayer } from 'react-leaflet';

const WmsLayerComponentInternal = ({ url, options, zIndex = 1, opacity = 1, minZoom, maxZoom, maxNativeZoom }) => {
  if (!url || !options || !options.layers) {
    console.error("WMS Layer requires 'url' and 'options' with 'layers' property.");
    return null;
  }

  return (
    <WMSTileLayer
      url={url}
      params={options}
      opacity={opacity}
      zIndex={zIndex}
      minZoom={minZoom}
      maxZoom={maxZoom}
      maxNativeZoom={maxNativeZoom}
    />
  );
};

export default React.memo(WmsLayerComponentInternal);
